import React from "react";
import DatePicker from "react-datepicker";
import range from "lodash/range";
import getYear from "date-fns/getYear";
import getMonth from "date-fns/getMonth";
import ru from 'date-fns/locale/ru';

const years = range(1990, getYear(new Date()) + 1, 1);
const months = [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь"
];


export default class Default extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: new Date(),
            label: 'deadline'
        };
    }

    handleChange = date => {
        this.props.changeNewDate(date, this.state.label)
    };

    handleChangeLabel = e => {
        let label = e.currentTarget.value;

        this.setState({
            label
        })
    };

    render() {
        return (
            <div className="row">
                <div className="column">
                    {/*<div className="date-label">
                        <input type="text" className='date-label__input' placeholder='Enter label'/>
                    </div>*/}
                    <DatePicker
                        selected={this.state.startDate}
                        onChange={this.handleChange}
                        withPortal
                        inline
                        locale={ru}
                        renderCustomHeader={({
                                                 date,
                                                 changeYear,
                                                 changeMonth,
                                                 decreaseMonth,
                                                 increaseMonth,
                                                 prevMonthButtonDisabled,
                                                 nextMonthButtonDisabled
                                             }) => {
                            return(
                                <div
                                    style={{
                                        margin: 10,
                                        display: "flex",
                                        justifyContent: "center"
                                    }}
                                >
                                    <div className="date-label">
                                        <input onChange={this.handleChangeLabel} type="text" className='date-label__input' value={this.state.label} placeholder='Enter label'/>
                                    </div>
                                    <button
                                        className="react-datepicker__navigation react-datepicker__navigation--previous"
                                        onClick={decreaseMonth}
                                        disabled={prevMonthButtonDisabled}
                                    >

                                    </button>
                                    <div className="react-datepicker__current-month">{months[getMonth(date)]} {getYear(date)}</div>
                                    <button
                                        className="react-datepicker__navigation react-datepicker__navigation--next"
                                        onClick={increaseMonth}
                                        disabled={nextMonthButtonDisabled}
                                    >

                                    </button>
                                </div>
                            )
                        }}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DatePickerCustom.js